import { render, staticRenderFns } from "./page-section.vue?vue&type=template&id=7018d267&scoped=true&"
import script from "./page-section.vue?vue&type=script&lang=ts&"
export * from "./page-section.vue?vue&type=script&lang=ts&"
import style0 from "./page-section.vue?vue&type=style&index=0&id=7018d267&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7018d267",
  null
  
)

export default component.exports